import styled from 'styled-components';

export const PlayerRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 34px;
`;

export const PlayButton = styled.button`
  flex-shrink: 0;
  align-self: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  background-color: transparent;
  -webkit-appearance: none;
  appearance: none;
  line-height: 0;
  /* Avoid Safari flex + opacity hover reflow (subpixel jump) */
  transform: translateZ(0);
  transition: background-color 0.15s ease;

  & svg {
    display: block;
    flex-shrink: 0;
  }

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.darkGray}1A;
  }

  &:active:not(:disabled) {
    background-color: ${({ theme }) => theme.darkGray}1A;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
`;

/** Slider only — sits in one row with play + time */
export const ProgressBlock = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
`;

export const TimeRow = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  font-size: 11px;
  line-height: 1;
  color: ${({ theme }) => theme.darkGray};
  user-select: none;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;

export const ProgressInput = styled.input.attrs({ type: 'range' })<{
  $progressPct: number;
}>`
  width: 100%;
  height: 6px;
  margin: 0;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
  background: transparent;

  --track: ${({ theme }) => theme.white};
  --fill: ${({ theme }) => theme.primary};

  background: linear-gradient(
    to right,
    var(--fill) 0%,
    var(--fill) ${({ $progressPct }) => $progressPct}%,
    var(--track) ${({ $progressPct }) => $progressPct}%,
    var(--track) 100%
  );
  border-radius: 3px;
  background-size: 100% 6px;
  background-position: center;
  background-repeat: no-repeat;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }

  &::-webkit-slider-runnable-track {
    height: 6px;
    border-radius: 3px;
    background: transparent;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 14px;
    height: 14px;
    margin-top: -4px;
    border-radius: 50%;
    background: ${({ theme }) => theme.white};
    border: 1px solid ${({ theme }) => theme.white};
    box-shadow: 0 0 0 1px ${({ theme }) => theme.mediumGray};
  }

  &::-moz-range-track {
    height: 6px;
    border-radius: 3px;
    background: transparent;
  }

  &::-moz-range-thumb {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: ${({ theme }) => theme.white};
    border: 1px solid ${({ theme }) => theme.white};
    box-shadow: 0 0 0 1px ${({ theme }) => theme.mediumGray};
  }
`;

export const HiddenAudio = styled.audio`
  display: none;
`;

export const LoadingHint = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.darkGray}a;
  opacity: 0.85;
`;

export const ErrorText = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.primary};
`;
